import doc         from '@widesk-core/decorators/doc';
import ImportModel from './ImportModel';

@doc.path('/imports/url')
export default class ImportUrlModel extends ImportModel {}
